import { connect } from 'react-redux'
import * as actions from './../../redux/actions'
import { withRouter } from 'react-router-dom';
import _ from 'lodash'

import ProductPage from './../../components/Product/ProductPage'

export default connect(
    (state, ownProps) => {
        const pageType = "edit";
        const {
            editProduct: { product, requesting, error, statistics },
            auth: { user },
        } = state
            , redirectWhenDoneRoute = "/products"
            , submitActionName = "Save"
        return { product, redirectWhenDoneRoute, requesting, error, user
            , submitActionName
            , statistics
            , pageType }
    },
    actions,
    (stateProps, dispatchProps) => {
        const selectedDispatchProps = {
            submitAction : dispatchProps.updateProductFields,
            clearFurnitureAddProduct : dispatchProps.clearFurnitureAddProduct,
            getStatisticsByProduct : dispatchProps.getStatisticsByProduct,
            getProduct : dispatchProps.getProduct,
            setConversionsBefore: dispatchProps.setConversionsBefore
        }
        return Object.assign({}, stateProps, selectedDispatchProps)
    }
)(withRouter(ProductPage))



// WEBPACK FOOTER //
// ./src/containers/Product/EditProduct.js